import React from 'react';

import * as ArchiveActions from 'archive/ArchiveActions';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import BenchlingConfig from 'BenchlingConfig';
import {NavStoreRegistry} from 'constants/RegistryConstants';
import FileBrowserUtil from 'file-browser/FileBrowserUtil';
// @ts-expect-error
import FilesForDeleteModal from 'folder-items/FilesForDeleteModal';
import * as RegistryUtil from 'registry/RegistryUtil';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import licenses from 'user/Licenses';

export interface DeleteOrArchiveRegistryButtonProps {
  onDelete?: () => void;
  registry: NavStoreRegistry;
}

/**
 * Render 'Delete Registry' button that opens confirmation modal before delete, or 'Archive Registry' button
 * that opens ArchiveModal if archiving is enabled.
 *
 * Hide button from enterprise users and registry non-admins. For enterprise users, we don't want to make
 * deletion or archiving user-friendly. They should go through support to delete or archive their registry.
 */
class DeleteOrArchiveRegistryButton extends React.Component<DeleteOrArchiveRegistryButtonProps> {
  private canDelete = (): boolean => {
    const hasDeleteAuth = RegistryUtil.hasSettingsAccess(this.props.registry);
    const isAcademicUser = !licenses.hasEnterprisePlan();
    return hasDeleteAuth && isAcademicUser;
  };

  private handleConfirmDelete = (): void => {
    const folderId = this.props.registry?.rootFolder.api_identifier;
    const nameAndOwnerComponent = FileBrowserUtil.getSourceNameAndOwnerComponent(this.props.registry, false);
    FilesForDeleteModal.open({
      deleteDescription: (
        <span>
          the registry <strong>{nameAndOwnerComponent}</strong>
        </span>
      ),
      doDelete: this.props.onDelete,
      fileIds: [folderId],
    });
  };

  private handleOpenArchiveModal = (): void => {
    ArchiveModal.open({items: [this.props.registry], onArchive: ArchiveActions.bulkArchiveRegistries});
  };

  render(): JSX.Element | null {
    if (!this.canDelete()) {
      return null;
    }
    return (
      <Button
        buttonStyle={ButtonStyle.NEGATIVE}
        onClick={BenchlingConfig.ENABLE_ARCHIVING_V2 ? this.handleOpenArchiveModal : this.handleConfirmDelete}
        size={ButtonSize.MEDIUM}
        text={BenchlingConfig.ENABLE_ARCHIVING_V2 ? 'Archive Registry' : 'Delete Registry'}
      />
    );
  }
}

export default DeleteOrArchiveRegistryButton;
